import React, { Fragment, useState } from 'react';
import classNames from 'classnames';

import Modal from './modal';

interface ModalProps {
  title: string;
  children: any;
  className?: string;
  buttonText: string;
  actionText: React.ReactNode;
  showCloseBtn?: boolean;
  modalContainerClasses?: string;
  titleClasses?: string;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}

const ModalWithActivationButton = (props: ModalProps) => {
  const [_open, _setOpen] = useState(false);

  const { open, setOpen, ...propsToPass } = props;

  return (
    <Fragment>
      <Modal
        open={open ?? _open}
        setOpen={setOpen ?? _setOpen}
        {...propsToPass}
      />

      <div>
        <button
          onClick={() => (setOpen ?? _setOpen)(true)}
          className={classNames(
            'font-secondary cursor-pointer antialiased flex items-center justify-center',
            'gap-x-2 text-white font-medium hover:text-[#B9BCDF] focus:outline-topaz',
            props?.className,
          )}
        >
          {props.actionText}
        </button>
      </div>
    </Fragment>
  );
};

export default ModalWithActivationButton;
